import BaseTaskRow from "./BaseTaskRow";
import LockTableTaskNameCellRenderer from "../renderers/LockTableTaskNameCellRenderer";
import TaskDayCellRenderer from "../renderers/TaskDayCellRenderer";

export default class TaskRow extends BaseTaskRow {
    constructor(taskDetailsFunc) {
        super();
        this.taskDetailsFunc = taskDetailsFunc;
    }

    createRowHeaderRenderer() {
        var cssClasses = "TaskCell";
        if (this.getHeaderCell().getValue().available) {
            cssClasses = this.appendOddEvenPrefix(cssClasses);
        }
        else {
            cssClasses += " notAvailableTaskCell";
        }

        if (this.isFirstChildRow()) {
            cssClasses += " detailsRowSeparator";
        }
        else if (this.hasRowSeparator()) {
            cssClasses += " taskNameTopBorder";
        }
        else if (!this.getHeaderCell().getValue().available) {
            cssClasses += " notAvailableTaskTopBorder";
        }
        return new LockTableTaskNameCellRenderer(cssClasses, this.taskDetailsFunc);
    }

    getTopBorderClass(cell) {
        var topBorderClass = BaseTaskRow.prototype.getTopBorderClass.call(this);
        if (!topBorderClass && this.isFirstNotAvailableChildRow()) {
            return "notAvailableTaskDetailsTopSeparator";
        }
        return topBorderClass;
    }

    isFirstNotAvailableChildRow() {
        if (this.getHeaderCell().getValue().available) {
            return false;
        }
        var childRows = this.getParentRow().getChildRows();
        for (var i = 0; i < childRows.length; i++) {
            var childRow = childRows[i];
            if (childRow instanceof BaseTaskRow && !childRow.getHeaderCell().getValue().available) {
                return childRow.getRowIdx() == this.getRowIdx();
            }
        }
        return false;
    }

    createLockCellRenderer() {
        return new TaskDayCellRenderer(this.getHeaderCell().getValue().available, this.appendOddEvenPrefix("DayDetailsCell"),
            this.getTopBorderClass(),
            this.getHeaderCell().getValue().completed);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/TaskRow.js